<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title title-typography-color">
              <i class="fas fa-user-tag"></i>
              {{ $t("public.components.role.Role.title") }}
            </h4>
          </template>
          <template v-slot:headerAction>
            <b-button v-if="
              checkPermissionProfessional('ORGANIZATION_ROLES', ['CREATE'])
            " style="right" variant="success" @click="openModal('CREATE', null)">{{
  $t("public.components.role.Role.btnCreate")
}}
            </b-button>
          </template>
          <template v-slot:body>
            <div v-if="checkPermissionProfessional('ORGANIZATION_ROLES', ['LIST'])" class="text-right">
              <b-button class="mb-3 mr-1" variant="secondary" @click="getRolesExcel">
                Excel
              </b-button>
            </div>
            <div>
              <v-data-table :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'fas fa-arrow-left',
                lastIcon: 'fas fa-arrow-right',
                prevIcon: 'fas fa-minus',
                nextIcon: 'fas fa-plus',
                'items-per-page-options': [10, 25, 50],
              }" :headers="headers" :items="roles" :options.sync="pagination" :server-items-length="total"
                item-key="id">
                <template v-slot:item.createdAt="{ item }">
                  <div v-if="item.createdAt">
                    {{ item.createdAt | adjustToTimezone("DD/MM/YYYY HH:mm") }}
                  </div>
                </template>
                <template v-slot:item.admin="{ item }">
                  <b-form-group label-for="active">
                    <b-form-checkbox v-model="item.superUserGalatea" size="lg" switch @change="
                      changeGalateaAdminRole(item.id, item.superUserGalatea)
                    "></b-form-checkbox>
                  </b-form-group>
                </template>
                <template v-slot:item.actions="{ item }">
                  <div class="div-table-data">
                    <button v-if="
                      checkPermissionProfessional('ORGANIZATION_ROLES', [
                        'LIST',
                      ])
                    " :id="'btnUpdate' + item.id" class="item" v-on:click="openModal('UPDATE', item.id)">
                      <i class="ri-refresh-line"></i>
                    </button>
                    <b-popover v-if="
                      checkPermissionProfessional('ORGANIZATION_ROLES', [
                        'LIST',
                      ])
                    " :target="'btnUpdate' + item.id" placement="botton" triggers="hover focus">
                      <template #title>{{
                        $t("public.components.role.Role.refreshPermision")
                      }}
                      </template>
                    </b-popover>
                  </div>
                </template>
              </v-data-table>
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-modal id="modal" cancel-title="Cerrar" centered ok-title="Crear" size="lg" title="Rol" @ok="saveFormStep1">
      <template #modal-title><span v-if="optionModal === 'CREATE'">{{
        $t("public.components.role.Role.modal.createRol")
      }}</span><span v-if="optionModal === 'UPDATE'">Actualizar rol</span></template>
      <template #modal-ok><span v-if="optionModal === 'CREATE'">{{
        $t("public.components.role.Role.modal.create")
      }}</span><span v-if="optionModal === 'UPDATE'">Actualizar</span></template>
      <form action="#">
        <b-form-group label-for="name">
          <template slot="label">{{ $t("public.components.role.Role.modal.name") }}: *
          </template>
          <b-form-input id="name" v-model="name" :disabled="disabled" type="text" v-bind:class="{
            'text-danger': isFormNameErrors,
            'is-invalid': isFormNameErrors,
          }" @blur="checkName(name)"></b-form-input>
          <ul v-if="isFormNameErrors">
            <li v-for="(error, index) in validatorStep1.getErrors('name')" v-bind:key="index"
              class="form-text text-danger">
              &nbsp;{{ error }}
            </li>
          </ul>
        </b-form-group>
        <b-form-group label-for="permissions">
          <template slot="label">{{ $t("public.components.role.Role.modal.permissions") }}:
            *
          </template>
        </b-form-group>
        <v-data-table :disable-pagination="true" :headers="headersPermissions" :items="permissions" hide-default-footer
          hide-default-header>
          <template v-slot:item.name="{ item }">
            {{
              $t(
                "public.components.role.Role.modal.permission.label." +
                item.permission
              )
            }}
          </template>
          <template v-slot:item.individual="{ item }">
            <v-layout row wrap>
              <div v-for="(i, index) in item.permissionTypes" :key="index" class="mr-2">
                <b-form-checkbox :id="'checkbox-permission-' + item.permission + '-' + index" v-model="i.active">
                  {{
                    $t(
                      "public.components.role.Role.modal.permission.checkbox." +
                      i.type
                    )
                  }}
                </b-form-checkbox>
              </div>
            </v-layout>
          </template>
        </v-data-table>
      </form>
    </b-modal>
    <notifications group="notificacions" />
  </b-container>
</template>
<script>
import { xray } from "../../config/pluginInit";
import { mapActions, mapGetters } from "vuex";

import validator from "vue-m-validator";

import roleService from "../../services/role";
import organizationService from "../../services/organization";

import utilsService from "../../services/utils";

export default {
  name: "Role",
  computed: {
    ...mapGetters({
      selectedOrganization: "Setting/organizationState",
    }),
  },
  props: {
    professionalId: {},
  },
  mounted() {
    xray.index();
    this.getOrganization();
    this.getAllOrganization();
  },
  computed: {
    isFormNameErrors() {
      let errors = this.validatorStep1.getErrors("name");
      return errors && errors.length > 0;
    },
  },
  methods: {
    //Galatea
    async changeGalateaAdminRole(roleId, admin) {
      let self = this;

      this.$awn.asyncBlock(
        roleService.changeGalateaAdminRole(roleId, admin),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_ROLES", info: "" });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "roleService.changeGalateaAdminRole",
            module: "component-role-role",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              roleId: roleId, admin: admin
            }),
          });
        },
        " "
      );
    },
    async getOrganization() {

      let self = this;

      this.$awn.asyncBlock(
        organizationService.get(localStorage.getItem("organizationId")),
        (response) => {
          if (response) {
            self.organization = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.get",
            module: "component-role-role",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: localStorage.getItem("organizationId")
            }),
          });
        },
        " "
      );

    },
    getRolesExcel() {
      utilsService.auditActivity({ action: "VIEW", module: "PROFESSIONAL_ROLES_EXCEL", info: "" });
      var objectUrl =
        process.env.VUE_APP_BASE_URL_CORE +
        "auth/roles/excel?token=" +
        localStorage.getItem("authorization");
      window.open(objectUrl);
    },
    checkPermissionProfessional(permission, permissionType) {
      return utilsService.checkPermissionProfessional(
        permission,
        permissionType
      );
    },
    notFirst() {
      this.isFirstRun = false;
    },
    checkName(_name) {
      const NAME = _name.trim();
      const RULE_1 = {
        expression: !NAME || NAME === "",
        name: "name",
        msg: this.$i18n.t("public.components.role.Role.errors.erName"),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    clearForm() {
      this.name = "";
    },
    openModal(option, id) {
      this.optionModal = option;

      if (option === "CREATE") {
        this.getAllPermissions();
        this.disabled = false;
        this.clearForm();
        this.validatorStep1.errors = [];
      }

      if (option === "UPDATE") {
        this.clearForm();
        this.validatorStep1.errors = [];
        this.get(id);
        this.disabled = false;
      }
    },
    getAllPermissions() {
      let self = this;

      this.$awn.asyncBlock(
        roleService.getAllPermissions(),
        (response) => {
          if (response) {
            self.permissions = response.data;
            this.$bvModal.show("modal");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "roleService.getAllPermissions",
            module: "component-role-role",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null,
          });
        },
        " "
      );
    },
    get(id) {
      let self = this;

      this.$awn.asyncBlock(
        roleService.get(id),
        (response) => {
          if (response) {
            self.id = response.data.id;
            self.name = response.data.name;
            self.permissions = response.data.permissions;
            this.$bvModal.show("modal");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "roleService.get",
            module: "component-role-role",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id
            }),
          });
        },
        " "
      );
    },
    update() {
      let self = this;

      let entity = {
        id: this.id,
        name: this.name,
        permissions: this.permissions,
      };

      this.$awn.asyncBlock(
        roleService.update(entity),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_ROLES", info: "" });
            self.getAllOrganization();
            self.$bvModal.hide("modal");

            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.components.role.Role.notifications.title"
              ),
              text: this.$i18n.t(
                "public.components.role.Role.notifications.refreshRole"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "roleService.update",
            module: "component-role-role",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              entity: entity
            }),
          });
        },
        " "
      );
    },
    create() {
      let self = this;

      let entity = {
        name: this.name,
        permissions: this.permissions,
      };

      this.$awn.asyncBlock(
        roleService.create(entity),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_ROLES", info: "" });
            self.getAllOrganization();
            self.$bvModal.hide("modal");

            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.components.role.Role.notifications.title"
              ),
              text: this.$i18n.t(
                "public.components.role.Role.notifications.createRole"
              ),
              type: "success",
            });
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "roleService.create",
            module: "component-role-role",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              entity: entity
            }),
          });
        },
        " "
      );
    },
    async getAllOrganization() {
      let self = this;

      this.$awn.asyncBlock(
        roleService.getAllWithOutPermissions(
          self.pagination.page - 1,
          self.pagination.itemsPerPage
        ),
        (response) => {
          if (response) {
            self.roles = response.data.content;
            self.total = response.data.total;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "roleService.getAllWithOutPermissions",
            module: "component-role-role",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              page: self.pagination.page - 1,
              items: self.pagination.itemsPerPage
            }),
          });
        },
        " "
      );
    },
    checkFormStep1() {
      this.checkName(this.name);
    },
    saveFormStep1(evt) {
      evt.preventDefault();
      this.checkFormStep1();
      if (this.validatorStep1.errors.length === 0) {
        if (this.optionModal === "CREATE") {
          this.create();
        }
        if (this.optionModal === "UPDATE") {
          this.update();
        }
      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t(
            "public.components.role.Role.notifications.error"
          ),
          text: this.$i18n.t(
            "public.components.role.Role.notifications.errorStep1"
          ),
          type: "error",
        });
      }
    },
  },
  data() {
    return {
      //Galatea
      organization: {},

      total: 0,
      pagination: { page: 1, itemsPerPage: 10 },

      //Form
      id: "",
      name: "",

      optionModal: "",
      disabled: false,
      isFirstRun: true,
      isValidateStep1: false,

      validatorStep1: validator,

      headersGalatea: [
        {
          text: this.$i18n.t("public.components.role.Role.headers.created"),
          align: "start",
          value: "createdAt",
        },
        {
          text: this.$i18n.t("public.components.role.Role.headers.rol"),
          value: "name",
        },
        {
          text: "Superadmin",
          value: "admin",
        },
        { text: "", value: "actions" },
      ],

      headers: [
        {
          text: this.$i18n.t("public.components.role.Role.headers.created"),
          align: "start",
          value: "createdAt",
        },
        {
          text: this.$i18n.t("public.components.role.Role.headers.rol"),
          value: "name",
        },
        {
          text: "Superadmin",
          value: "admin",
        },
        { text: "", value: "actions" },
      ],

      headersPermissions: [
        {
          text: this.$i18n.t("public.components.role.Role.headers.name"),
          align: "start",
          value: "name",
        },
        { text: "", value: "individual" },
      ],
      roles: [],
      permissions: [],
    };
  },
};
</script>
